import type { Category } from "../../../../shared/types";
import { CATEGORY_DOT_COLORS } from "../../../../shared/types";
import { useCategories } from "../../../../shared/stores/category-store";
import { CustomSelect } from "../../../../ui/atoms/CustomSelect";
import { DateInput } from "./DateInput";

export interface BasicFieldsProps {
  readonly title?: string;
  readonly onTitleChange?: (value: string) => void;
  readonly date: string;
  readonly onDateChange: (date: string) => void;
  readonly category: Category;
  readonly onCategoryChange: (category: Category) => void;
  readonly allDay: boolean;
  readonly onAllDayChange: (checked: boolean) => void;
}

export function BasicFields({
  title,
  onTitleChange,
  date,
  onDateChange,
  category,
  onCategoryChange,
  allDay,
  onAllDayChange,
}: BasicFieldsProps) {
  const { categories, labels } = useCategories();

  return (
    <>
      {title !== undefined && onTitleChange && (
        <div>
          <label className="block text-[10px] font-medium text-ink-faint uppercase tracking-wide mb-1">
            Titre
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => onTitleChange(e.target.value)}
            placeholder="Titre de l'événement"
            className="w-full px-2.5 py-1.5 text-xs text-ink bg-surface border border-border/60 rounded-md focus:outline-none focus:border-accent/60"
          />
        </div>
      )}
      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="block text-[10px] font-medium text-ink-faint uppercase tracking-wide mb-1">
            Date
          </label>
          <DateInput value={date} onChange={onDateChange} />
        </div>
        <div>
          <label className="block text-[10px] font-medium text-ink-faint uppercase tracking-wide mb-1">
            Catégorie
          </label>
          <CustomSelect
            value={category}
            onChange={(val) => onCategoryChange(val as Category)}
            options={categories.map((cat) => ({
              value: cat,
              label: labels[cat],
              dot: CATEGORY_DOT_COLORS[cat],
            }))}
            className="w-full"
          />
        </div>
      </div>

      <label className="flex items-center gap-2 cursor-pointer group">
        <div className="relative">
          <input
            type="checkbox"
            checked={allDay}
            onChange={(e) => onAllDayChange(e.target.checked)}
            className="sr-only"
          />
          <div className={`w-4 h-4 rounded-full border-2 transition-all flex items-center justify-center
            ${allDay
              ? "bg-accent border-accent"
              : "border-border group-hover:border-accent/50"
            }`}>
            {allDay && (
              <svg viewBox="0 0 24 24" className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" strokeWidth={3}>
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </div>
        </div>
        <span className="text-[11px] font-medium text-ink-muted">
          Toute la journée
        </span>
      </label>
    </>
  );
}
